module.exports = __webpack_public_path__ + "img/Logo-Televet Play-White.7a39e999.png";